import { render, staticRenderFns } from "./ims_setting.vue?vue&type=template&id=b33c6034&scoped=true"
import script from "./ims_setting.vue?vue&type=script&lang=js"
export * from "./ims_setting.vue?vue&type=script&lang=js"
import style0 from "./ims_setting.vue?vue&type=style&index=0&id=b33c6034&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33c6034",
  null
  
)

export default component.exports